import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();
  console.log("location: ", location);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const logoImage =
    location.pathname === "/" ? "/images/Logo.png" : "/images/Logo1.png";

  return (
    <nav className="text-[#222] bg-[#fafafa] relative">
      <div className="container mx-auto flex justify-between items-center px-4 md:px-1.5 py-3.5">
        <div className="md:hidden" />
        {/* Logo */}
        <Link
          to="/"
          className="absolute left-1/2 transform -translate-x-1/2 md:relative md:left-0 md:transform-none"
        >
          <img
            id="logo"
            src={logoImage}
            alt="Logo"
            className={`max-h-[65px]`}
          />
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-12 text-[18px]">
          <a href="/booking?event=leafwell-nature-stay" className="text-[17px] font-semibold">
            Book&nbsp;Now
          </a>
          <div className="relative">
            <button
              onClick={toggleDropdown}
              className="flex gap-1 items-center text-[17px]"
            >
              Live@Leafwell <img src="/icons/dropdown.svg" alt="" />
            </button>
            {isDropdownOpen && (
              <div className="absolute min-w-[215px] top-[130%] mt-2 border text-[16px] text-[#222] rounded-xl shadow-lg py-5 z-50 bg-[#fafafa]">
                <a href="/build" className="block px-4 py-2">
                  Rent at Leafwell
                </a>
                <a href="/cabins" className="block px-4 py-2">
                  Your Suite
                </a>
                <a href="/locations/nyc" className="block px-4 py-2">
                  Our Properties
                </a>
                {/* <a href="/invest" className="block px-4 py-2">Invest in Glamping</a> */}
              </div>
            )}
          </div>
          <a href="/about" className="text-[17px]">
            Meet the Team
          </a>
          <a href="/contact" className="text-[17px]">
            Get in Touch
          </a>
          <a href="/faqs" className="text-[17px]">
            FAQs
          </a>
        </div>

        <div className="hidden md:block" />

        {/* Mobile Menu Button */}
        <div
          className={`md:hidden flex items-center ${
            isMobileMenuOpen ? "bg-black" : "bg-[#eee]"
          } rounded-md min-h-[40px] px-3`}
        >
          <button onClick={toggleMobileMenu}>
            <svg
              className={`w-6 h-6 ${
                isMobileMenuOpen ? "text-white" : "text-[#222]"
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="absolute top-full left-0 right-0 border mx-2 rounded-xl flex flex-col items-center py-4 text-[20px] gap-4 bg-[#fafafa] z-50">
          <a href="/booking?event=leafwell-nature-stay" className="block px-4 py-2 font-semibold">
            Book&nbsp;Now
          </a>
          <div className="relative w-full flex flex-col items-center">
            <p onClick={toggleDropdown} className="px-4 py-2 flex items-center">
              Live@Leafwell <img src="/icons/dropdown.svg" alt="" />
            </p>
            {isDropdownOpen && (
              <div className="border rounded-xl py-4 px-6 flex flex-col items-center text-[16px] bg-[#fafafa] z-50">
                <a href="/build" className="block px-4 py-2">
                  Rent at Leafwell
                </a>
                <a href="/cabins" className="block px-4 py-2">
                  Your Suite
                </a>
                <a href="/locations/nyc" className="block px-4 py-2">
                  Our Properties
                </a>
                {/* <a href="/invest" className="block px-4 py-2">Invest in Glamping</a> */}
              </div>
            )}
          </div>
          <a href="/contact" className="block px-4 py-2">
            Get in Touch
          </a>
          <a href="/about" className="block px-4 py-2">
            Meet the Team
          </a>
          <a href="/faqs" className="block px-4 py-2">
            FAQs
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
